import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_van_cell_group = _resolveComponent("van-cell-group");
  const _component_PageNavBackLayoutCpt = _resolveComponent("PageNavBackLayoutCpt");
  return _openBlock(), _createBlock(_component_PageNavBackLayoutCpt, {
    class: "page"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_cell_group, {
      title: "产品基本信息"
    }, {
      default: _withCtx(() => [_createVNode(_component_van_cell, {
        title: "合作机构",
        value: _ctx.formatSelectColumn($data.otherResItems, 'partnerId', {
          partnerId: $data.production.partnerId
        })
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "产品代码",
        value: $data.production.productCode
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "产品名称",
        value: $data.production.productName
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "产品类型",
        value: _ctx.formatSelectColumn($data.codeResItems, 'productType', {
          productType: $data.production.productType
        })
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "产品子类型",
        value: _ctx.formatSelectColumn($data.codeResItems, 'productSubType', {
          productSubType: $data.production.productSubType
        })
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "引入日期",
        value: $data.production.introductionDate
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "销售状态",
        value: _ctx.formatSelectColumn($data.codeResItems, 'salesStatus', {
          salesStatus: $data.production.salesStatus
        })
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "产品形态",
        value: _ctx.formatSelectColumn($data.codeResItems, 'productForm', {
          productForm: $data.production.productForm
        })
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "募集机构",
        value: _ctx.formatSelectColumn($data.codeResItems, 'raisedOrganization', {
          raisedOrganization: $data.production.raisedOrganization
        })
      }, null, 8, ["value"])]),
      _: 1
    }), _createVNode(_component_van_cell_group, {
      title: "产品要素信息"
    }, {
      default: _withCtx(() => [_createVNode(_component_van_cell, {
        title: "产品类别",
        value: _ctx.formatSelectColumn($data.codeResItems, 'wealthCategory', {
          wealthCategory: $data.productExtra.wealthCategory
        })
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "风险等级",
        value: _ctx.formatSelectColumn($data.codeResItems, 'riskGrade', {
          riskGrade: $data.productExtra.riskGrade
        })
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "分配方式",
        value: _ctx.formatSelectColumn($data.codeResItems, 'distributionMethod', {
          distributionMethod: $data.productExtra.distributionMethod
        })
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "适合投资人类型",
        value: $data.productExtra.custRiskLevelValue
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "募集规模(万)",
        value: $data.productExtra.expectedRaiseScale
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "募集开始日",
        value: $data.productExtra.raiseStartDate
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "募集结束日",
        value: $data.productExtra.raiseEndDate
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "成立日",
        value: $data.productExtra.foundDate
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "起息日",
        value: $data.productExtra.calInterestDate
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "到期日",
        value: $data.productExtra.expectedExpireDate
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "实际到期日",
        value: $data.productExtra.actualExpireDate
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "封闭期",
        value: $data.productExtra.closePeriod
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "封闭期单位",
        value: _ctx.formatSelectColumn($data.codeResItems, 'closePeriodUnit', {
          closePeriodUnit: $data.productExtra.closePeriodUnit
        })
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "产品经理",
        value: _ctx.formatSelectColumn($data.otherResItems, 'productManagerId', {
          productManagerId: $data.productExtra.productManagerId
        })
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "产品状态",
        value: _ctx.formatSelectColumn($data.codeResItems, 'productStatus', {
          productStatus: $data.productExtra.productStatus
        })
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "募集账户名称",
        value: $data.productExtra.accountName
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "开户银行",
        value: $data.productExtra.bankName
      }, null, 8, ["value"]), _createVNode(_component_van_cell, {
        title: "银行账号",
        value: $data.productExtra.bankAccount
      }, null, 8, ["value"])]),
      _: 1
    })]),
    _: 1
  });
}